import React, { useState, useEffect } from "react";
import getData from "../Custome_Components/commonAPISelect";
import Loading from "../Custome_Components/Loading";
import DataTable from '../Custome_Components/DataTable';
import { IoMdRefresh } from "react-icons/io";
import { IoSearchOutline } from "react-icons/io5";
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.black,
        fontSize: '14px',
    },
}));

function AllTask() {

    const [TableData, setTableData] = useState([]);
    const [DatasCount, setDatasCount] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        OpenCloseCountFunc();
        handleTrackTable();
    }, []);

    useEffect(() => {
        const filtered = TableData.filter((row) =>
            Object.values(row).some((value) =>
                value?.toString().toLowerCase().includes(searchTerm.toLowerCase())
            )
        );
        setFilteredData(filtered);
    }, [searchTerm, TableData]);

    const handleRefresh = () => {
        handleTrackTable();
        OpenCloseCountFunc();
    }

    const handleTrackTable = async () => {
        setLoading(true);
        const response = await getData("VwAPINSEIPLClientPortal/", {
            data: {
                p1_int: 10,
                UserID_int: localStorage.getItem("EmpID")
            },
        });
        const {
            Output: { status },
        } = response;
        if (response.Output.status.code == "200") {
            const formattedRows = response?.Output?.data?.map((item, index) => ({
                id: index + 1,
                ...item
            }));
            setTableData(formattedRows || []);
            setLoading(false);
        } else {
            console.error("Error fetching data:", status.message);
            setLoading(false);
        }
    };

    const OpenCloseCountFunc = async () => {
        setLoading(true);
        const response = await getData("VwAPINSEIPLClientPortal/", {
            data: {
                p1_int: 11,
                UserID_int: localStorage.getItem("EmpID")
            },
        });
        const { Output: { status, data } } = response;
        if (response.Output.status.code == "200") {
            setDatasCount(data || []);
            setLoading(false);
        } else {
            console.error("Error fetching data:", status.message);
            setLoading(false);
        }
    };

    const userColumns = [
        {
            field: 'TicketNo', headerName: 'Ticket No', flex: 0.5,
            renderCell: (params) => (
                <span className='ticketNoStyle'>
                    {params.value}
                </span>),
        },
        { field: 'Date', headerName: 'Date', flex: 0.5 },
        { field: 'RequestType', headerName: 'Request Type', flex: 0.5 },
        { field: 'RequestBy', headerName: 'Request By', flex: 0.5 },
        { field: 'Description', headerName: 'Description', flex: 5 },
        {
            field: 'Status', headerName: 'Status', flex: 0.5,
            renderCell: (params) => {
                return (
                    <>
                        <span className="RaisedRowStatusStyle"
                            style={{
                                color: params.value.toLowerCase() == "open" ? "#d80000" : "#3d8c00",
                                backgroundColor: params.value.toLowerCase() == "open" ? "#ff00001a" : "#49a9001a"
                            }}>{params.value}</span>
                    </>);
            }
        }
    ];


    return (
        <div style={{ width: "100%", height: "100%" }}>
            <Loading loading={loading}>
                <div className="TablePageParent">
                    <div className="TableHeadingSection">

                        <div className="TableTabSection">
                            <div className="AllTaskTotalSec">
                                Total - {DatasCount && DatasCount.length > 0 && DatasCount[0].Total ? DatasCount[0].Total : 0}</div>
                            <div className="AllTaskOpenSec">
                                Open - {DatasCount && DatasCount.length > 0 && DatasCount[0].OpenWo ? DatasCount[0].OpenWo : 0}</div>
                            <div className="AllTaskClosedSec">
                                Closed - {DatasCount && DatasCount.length > 0 && DatasCount[0].Closed ? DatasCount[0].Closed : 0}</div>
                        </div>

                        <div className="TableSearchSection">
                            <BootstrapTooltip title={"Refresh"} placement="top">
                                <div className="WeeklyTaskRefreshParent" onClick={handleRefresh}>
                                    <IoMdRefresh className="WeeklyRefreshIcon" />
                                </div>
                            </BootstrapTooltip>

                            <div className="TableSearchInputDiv">
                                <input
                                    type="text"
                                    placeholder="Search here"
                                    className="TableSerFil"
                                    value={searchTerm}
                                    onChange={(Event) => setSearchTerm(Event.target.value)}
                                />
                                <IoSearchOutline className="FaSearchTableStyle" />
                            </div>
                        </div>
                    </div>

                    <div className="TableParentDiv">
                        <DataTable
                            rows={filteredData}
                            columns={userColumns}
                            pageSize={10}
                            height={500}
                        />
                    </div>
                </div>
            </Loading>
        </div>

    )
}

export default AllTask;